import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoins, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { useMemo } from 'react';
import cn from 'classnames';
import { Tooltip } from 'components/Tooltip';
import styles from 'pages/Schedule/Schedule.scss';

export const PaymentsCell = ({ booking }) => {
  const allPayments = useMemo(
    () => [
      ...booking.participants.map((p) => p.payment).filter(Boolean),
      ...booking.coaches.map((c) => c.payment).filter(Boolean),
    ],
    [booking.participants, booking.coaches]
  );

  const total = useMemo(() => allPayments.reduce((sum, p) => sum + p.amount, 0), [allPayments]);

  const paid = useMemo(() => allPayments.reduce((sum, p) => sum + p.paidAmount, 0), [allPayments]);

  const overdue = useMemo(() => allPayments.some((p) => !p.paid && new Date(p.dueTime) < new Date()), [allPayments]);

  if (!allPayments.length)
    return (
      <div className={cn(styles.tableCell, styles.payment)}>
        <span className={styles.noPayment}>Без оплати</span>
      </div>
    );

  return (
    <div className={cn(styles.tableCell, styles.payment)}>
      {allPayments.length > 0 && (
        <>
          <FontAwesomeIcon className={styles.coins} icon={faCoins} />
          <span className={styles.amount}>
            {paid < total && `${paid} / `}
            {total} ₴
          </span>
          {!allPayments.every((p) => p.paid) && overdue && (
            <div className={styles.info}>
              <FontAwesomeIcon
                className={cn(styles.paymentStatus, {
                  [styles.partial]: paid > 0 && paid < total,
                  [styles.unpaid]: paid === 0,
                })}
                icon={faExclamationCircle}
              />
              <Tooltip
                className={styles.paymentInfo}
                text={paid !== total && paid > 0 ? 'Часткова оплата' : 'Не оплачено'}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};
